import { render, staticRenderFns } from "./FlexibleContent.vue?vue&type=template&id=833a3cdc"
import script from "./FlexibleContent.vue?vue&type=script&lang=js"
export * from "./FlexibleContent.vue?vue&type=script&lang=js"
import style0 from "./FlexibleContent.vue?vue&type=style&index=0&id=833a3cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports